import { atom } from 'jotai';

import { createDerivedWritableAtom } from '../../utils';
import { AudioRecordingState, participantCountAtom, recordingStateAtom } from '../../video-sdk';
import { providerAtom } from '../state';

export const shouldRecordAtom = atom((get) => {
  const isRecordingEnabled = get(recordingStateAtom).value === AudioRecordingState.RECORDING;
  const hasParticipants = !!get(participantCountAtom);
  return isRecordingEnabled && hasParticipants;
});

export const audioRecordingEntitiesAtom = createDerivedWritableAtom(providerAtom, 'audioRecordingEntities');

export const recordingAudioContextAtom = atom((get) => get(audioRecordingEntitiesAtom)?.audioContext);

export const recordingAudioDestinationNodeAtom = atom((get) => get(audioRecordingEntitiesAtom)?.audioDestinationNode);

export const audioRecorderAtom = atom((get) => get(audioRecordingEntitiesAtom)?.audioRecorder);

export const hasRecordingAtom = atom(false);

export const audioRecordingSilentRecoveryAttemptCountAtom = atom(0);
